import { clampUnit, Random, StringMapping, ValueMapping } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
export class VelocityDeviceBoxAdapter {
    type = "midi-effect";
    accepts = "midi";
    #context;
    #box;
    #parametric;
    #random;
    namedParameter; // let typescript infer the type
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#parametric = new ParameterAdapterSet(this.#context);
        this.#random = Random.create();
        this.namedParameter = this.#wrapParameters(box);
    }
    computeVelocity(position, original) {
        const { magnetPosition, magnetStrength, randomSeed, randomAmount, offset, mix } = this.namedParameter;
        this.#random.setSeed(randomSeed.valueAt(position) + position);
        const magnet = original + (magnetPosition.valueAt(position) - original) * magnetStrength.valueAt(position);
        const random = (this.#random.uniform() * 2.0 - 1.0) * randomAmount.valueAt(position);
        const delta = offset.valueAt(position);
        const wet = mix.valueAt(position);
        return original * (1.0 - wet) + (clampUnit(magnet + random + delta)) * wet;
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get indexField() { return this.#box.index; }
    get labelField() { return this.#box.label; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get host() { return this.#box.host; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { this.#parametric.terminate(); }
    #wrapParameters(box) {
        return {
            magnetPosition: this.#parametric.createParameter(box.magnetPosition, ValueMapping.unipolar(), StringMapping.percent(), "Position"),
            magnetStrength: this.#parametric.createParameter(box.magnetStrength, ValueMapping.unipolar(), StringMapping.percent(), "Strength"),
            randomSeed: this.#parametric.createParameter(box.randomSeed, ValueMapping.linearInteger(0, 0xFFFF), StringMapping.numeric({ unit: "", fractionDigits: 0 }), "Seed"),
            randomAmount: this.#parametric.createParameter(box.randomAmount, ValueMapping.unipolar(), StringMapping.percent(), "Amount"),
            offset: this.#parametric.createParameter(box.offset, ValueMapping.bipolar(), StringMapping.percent(), "Offset"),
            mix: this.#parametric.createParameter(box.mix, ValueMapping.unipolar(), StringMapping.percent(), "Mix")
        };
    }
}
